import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_SALARY_STRUCTURE);

var axios_instance_ss_details = get_axios_instance(api_variables.SERVICE_SALARY_STRUCTURE_DETAILS);

const _pk_name = 'id';

const state = {
    entityWiseData: {},
    salaryStructureDetail: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    isCustomStructure: false
};

const mutations = {
    set: (state, [payload, leId]) => {
        state.entityWiseData[leId] = payload;
        state.entityWiseData = {...state.entityWiseData };
    },

    setSalaryStructureData: (state, payload) => {
        state.salaryStructureDetail = {};
        state.salaryStructureDetail = payload;
    },

    addEntity: (state, [payload, id]) => {
        if (!state.entityWiseData[id]) {
            state.entityWiseData[id] = [payload];
        } else {
            state.entityWiseData[id].push(payload);
        }
    },

    updateEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.entityWiseData[id].length; i++) {
            if (state.entityWiseData[id][i][_pk_name] === payload.id) {
                state.entityWiseData[id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, leId]) => {
        for (let i = 0; i < state.entityWiseData[leId].length; i++) {
            if (state.entityWiseData[leId][i][_pk_name] == payload) {
                state.entityWiseData[leId].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setCustomStructure: (state, payload) => {
        state.isCustomStructure = payload;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                if (res.data.payload.length) commit('set', [res.data.payload, payload]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchSalaryStructureComponents({commit}, payload) {
        //console.log("[state/dashboard/oganisation/salaryStructure/fetchAll] Calling API...",payload);
      try {
        commit("setFetching", true);
        let res = await axios_instance_ss_details.get(`/`, {
          params: {
            ss_id: payload.id,
            le_id: payload.leId,
            type: payload.type && payload.type 
          }
        });

        commit("setFetching", false);
        //console.log("[state/dashboard/oganisation/salaryStructure/fetchAll] res: ", res);
       commit("setSalaryStructureData", res.data.payload[0]);
        return res;
      } catch (error) {
        //console.log(error);
          // throw errorHandler(error.response);
      }
    },

    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.post('/', payload);
            commit('setSaving', false);
            if (res.status == 201) {
                commit('addEntity', [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.put(`/` + payload.data.id, payload);
            commit('setSaving', false);
            if (res.status == 201 || res.status == 200) {
                commit('updateEntityById', [res.data.payload, payload.data.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, [payload, le_id]) {
        try {
            commit('setDeleting', true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit('setDeleting', false);
            if (res.status == 200) {
                commit('removeEntityById', [payload.id, payload.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async addCustomStructure({ commit }, status) {
        try {
            commit('setCustomStructure', status);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
